<template>
  <div>
    <v-row class="mb-2 mt-1 px-2" align="center">
      <v-col cols="12" sm="6" md="4">
        <autocomplete
          v-model="selectedMeals"
          :items="mealItems"
          :label="$t('meal_meal')"
          multiple
          clearable
          hide-details
          chips
          deletable-chips
          select-all
        />
      </v-col>
    </v-row>
    <apexchart
      v-if="hasDates && dayCategories.length && selectedMeals.length"
      type="bar"
      height="460"
      :options="chartOpts"
      :series="chartSeries"
    />
    <empty-state
      v-else
      icon="mdi-food-drumstick-outline"
      :title="selectedMeals.length ? $t('no_data') : $t('select_food')"
    />
  </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";
import EmptyState from "@/components/global/EmptyState.vue";
import { CHART_FONT, GRID_COLOR } from "@/components/statistics-report/statsTheme";

export default {
  name: "GroupMealsDaysMealsChart",
  components: { apexchart: VueApexCharts, EmptyState },
  props: {
    orders: { type: Array, default: () => [] },
  },
  data() {
    return {
      selectedMeals: [],
    };
  },
  computed: {
    hasDates() {
      return this.orders.some((item) => !!item.date);
    },
    mealNames() {
      const set = new Set();
      for (const item of this.orders) {
        if (item.meal_name) set.add(item.meal_name);
      }
      return [...set].sort();
    },
    mealItems() {
      return this.mealNames.map((m) => ({ text: this.toLatin(m), value: m }));
    },
    // { date: { meal_name: total } }
    agg() {
      const map = {};
      for (const item of this.orders) {
        if (!item.date || !item.meal_name) continue;
        if (!this.selectedMeals.includes(item.meal_name)) continue;
        if (!map[item.date]) map[item.date] = {};
        const qty =
          item.shift_1 !== undefined
            ? Number(item.shift_1 || 0) + Number(item.shift_2 || 0) + Number(item.shift_3 || 0) + Number(item.shift_4 || 0)
            : Number(item.quantity || 0);
        map[item.date][item.meal_name] = (map[item.date][item.meal_name] || 0) + qty;
      }
      return map;
    },
    dayCategories() {
      return Object.keys(this.agg).sort();
    },
    chartSeries() {
      return this.selectedMeals.map((meal) => ({
        name: this.toLatin(meal),
        data: this.dayCategories.map((date) => this.agg[date]?.[meal] || 0),
      }));
    },
    chartOpts() {
      return {
        chart: {
          type: "line",
          toolbar: { show: true },
          zoom: { enabled: true },
          fontFamily: CHART_FONT,
        },
        stroke: { curve: "smooth", width: 2 },
        markers: { size: 4 },
        xaxis: {
          categories: this.dayCategories,
          labels: { style: { fontSize: "11px" } },
        },
        legend: { position: "bottom" },
        dataLabels: { enabled: false },
        tooltip: { shared: true, intersect: false },
        fill: { opacity: 1 },
        grid: { borderColor: GRID_COLOR },
        responsive: [
          {
            breakpoint: 600,
            options: {
              chart: { height: 360 },
              xaxis: { labels: { style: { fontSize: "10px" } } },
              legend: { fontSize: "12px" },
            },
          },
        ],
      };
    },
  },
};
</script>

